import { Navigate } from 'react-router-dom';
import { useSignOut } from '../../hooks/signout/useSignOut';

/**
 * Sign Out page component - refactored to separate business logic from UI.
 * All business logic is now in custom hooks, making it reusable for React Native.
 */
export const SignOutPage = () => {
  // Business logic hook (platform-agnostic)
  const { isComplete } = useSignOut();

  // Redirect to login after sign out completes
  if (isComplete) {
    return <Navigate to="/login" />;
  }

  return <p>Signing out...</p>;
};
